const InsightsTest = () => {
  return <div></div>;
};

export const getServerSideProps = async () => {
  let test = null;

  if (test.insights_test) {
    test = {};
  }

  return {
    props: {},
  };
};

export default InsightsTest;
